export const TEST_ID = 'resultRow';

// Icon glyph geometry — each icon is 16×16 to match the prototype, rendered
// through currentColor so consumers can retint via the SCSS icon slot.
export const ICON_SIZE = 16;

export const ICON_STROKE_WIDTH = 1.5;

// Clock (recent) — circle + hour-hand polyline.
export const CLOCK_CIRCLE_CENTER = 8;

export const CLOCK_CIRCLE_RADIUS = 6.5;

export const CLOCK_STROKE_WIDTH = 1.4;

export const CLOCK_POLYLINE_POINTS = '8,4 8,8 11,10';

// Airport 8-point star path — filled, no stroke.
export const STAR_PATH = 'M 8 1.5 L 9.2 7 L 14.5 8 L 9.2 9 L 8 14.5 L 6.8 9 L 1.5 8 L 6.8 7 Z';

// Map-pin outline — outer teardrop + inner circle cutout.
export const PIN_TEARDROP =
    'M8 1 C 5 1, 3 3, 3 6 C 3 9.5, 8 15, 8 15 C 8 15, 13 9.5, 13 6 C 13 3, 11 1, 8 1 Z';

export const PIN_CIRCLE_CX = 8;

export const PIN_CIRCLE_CY = 6;

export const PIN_CIRCLE_R = 2;

// Chevron — 14×14 viewBox, 1.8px stroke, points right.
export const CHEVRON_SIZE = 14;

export const CHEVRON_POINTS = '5,2 10,7 5,12';

export const CHEVRON_STROKE_WIDTH = 1.8;
